import React, { useState } from 'react';
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';

import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import axios from "axios";
import AxiosInstance from 'src/components/Axios';
import CIcon from '@coreui/icons-react';
import { cilPen, cilPlus, cilTrash, cilClone, cilPrint } from '@coreui/icons';
import { confirmAlert } from 'react-confirm-alert';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";

const page = 1;
const postPerPage = 0;
const pageSize = 20;
const urlApi = '/roles';

export async function LoaderRoles({ params }) {
   let res = await AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => {
      return response;
   });
   return res;
}


const Roles = ({ user_data }) => {

   // if (!Permissions(user_data, 'Roles', 'VIEW_ROLES')) {
   //    return <PermissionsNoPage />;
   // }

   const { data } = useLoaderData();
   const [rows, setRows] = useState(data['hydra:member']);
   const [rowCount, setRowCount] = useState(data['hydra:totalItems'])

   const getRowsTable = () => {
      AxiosInstance.get(`${urlApi}?page=${page}`).then((response) => {
         if (response.status == 200)
            setRows(response.data['hydra:member']);
         setRowCount(response.data['hydra:totalItems'])
      });
   }
   const popup = MyToastify();

   function Deleted(row) {
      // console.log('row', row);
      confirmAlert({
         title: 'Ви впевнені що хочите видалити цей пункт ?',
         // message: 'Are you sure to do this.',
         message: (<></>),
         buttons: [
            {
               label: 'Так',
               onClick: () => {
                  const response = AxiosInstance.delete(urlApi + '/' + row.id).then((response) => {
                     getRowsTable();
                     // Вивести popup про успішне видалення замовлення
                     popup.toastifySuccess('Видалено');
                  });
               }
            },
            {
               label: 'Ні',
               onClick: () => {
                  return;
               }
            }
         ]
      });
   };

   const columns = [
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'name', headerName: 'Назва', width: 200 },
      { field: 'label', headerName: 'Опис', width: 200 },
      {
         field: "action",
         headerName: "Action",
         sortable: false,
         headerName: "Редагувати",
         align: 'center',
         width: 100,
         renderCell: (params) => {
            return <Link to={'/roles/view/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
         }
      },
      // {
      //    field: "delete",
      //    headerName: "Видалити",
      //    sortable: false,
      //    headerName: "Видалити",
      //    align: 'center',
      //    width: 100,
      //    renderCell: (params) => {
      //       return <CButton color="danger" variant="outline" onClick={() => { Deleted(params.row) }}>
      //          <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
      //       </CButton>;
      //    }
      // },
   ];


   return (
      <CRow>
         <ToastContainer />

         <CCol xs={12}>
            <CCard className="mb-4 mt-4">
               <CCardHeader className='items_card_header'>
                  {/* <strong> */}
                  Ролі
                  {/* </strong> */}
               </CCardHeader>
               <CCardBody>
                  <div className='head_items_wrapper_solo'>
                     <p className="text-medium-emphasis small">
                        <Link to="/roles/create" className='link_add_button'>
                           {/* Створити */}
                           <CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                              {/* Створити */}
                              Створити
                           </CButton>
                        </Link>
                     </p>
                  </div>
                  <div style={{ height: 600, width: '100%' }}>
                     <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={30}
                        rowsPerPageOptions={[30]}
                        pagination
                        rowCount={rowCount}
                        paginationMode="server"
                     />
                  </div>
               </CCardBody>
            </CCard>
         </CCol>
      </CRow>
   );
};

export default Roles;
